import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const GPGKeysResourceLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./gpg-keys'),
});
